var map = {
	"./icon0.png": "./src/assets/image/well/icon0.png",
	"./icon1.png": "./src/assets/image/well/icon1.png",
	"./icon2.png": "./src/assets/image/well/icon2.png",
	"./icon3.png": "./src/assets/image/well/icon3.png",
	"./icon5.png": "./src/assets/image/well/icon5.png",
	"./icon6.png": "./src/assets/image/well/icon6.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/image/well sync recursive ^\\.\\/icon.*\\.png$";